var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-History_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "History_Icon",
    "data-name": "History Icon",
    clipPath: "url(#clip-History_Icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "translate(-1.057 -1.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641",
    transform: "translate(1.057 2.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M7.632,20.334H2.494A1.306,1.306,0,0,1,1.059,18.9c0-1.224.021-.875,0-2.1A3.687,3.687,0,0,1,2.67,13.628,5.806,5.806,0,0,1,4.1,12.866a.248.248,0,0,1,.287.051,5.325,5.325,0,0,0,6.48.008.246.246,0,0,1,.268-.061,4.174,4.174,0,0,1,3.032,3.294,3.134,3.134,0,0,1,.034.571c0,1.254,0,.935,0,2.189a1.3,1.3,0,0,1-1.41,1.416Q10.213,20.336,7.632,20.334Z",
    transform: "translate(-1.057 -4.812)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M8.346,10.524a3.946,3.946,0,1,1,3.944-3.963A3.952,3.952,0,0,1,8.346,10.524Z",
    transform: "translate(-1.77 -2.632)",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(14.908 6.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_02",
    "data-name": "Icon 02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0.211 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M19.072,14.611c-.008-.016-.723-1.594,1.2-2.806.065-.039.244-.175.244-.289s-.179-.25-.242-.288c-1.921-1.214-1.206-2.791-1.2-2.807l.176.083c-.027.058-.644,1.44,1.125,2.559.032.02.334.209.334.455s-.3.434-.336.455c-1.774,1.121-1.129,2.543-1.123,2.557Z",
    transform: "translate(-18.935 -8.42)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M22.816,8.4H18.667V7.945a.3.3,0,0,1,.3-.3h3.558a.3.3,0,0,1,.295.3Zm-3.954-.2h3.759V7.945a.1.1,0,0,0-.1-.1H18.963a.1.1,0,0,0-.1.1h0Z",
    transform: "translate(-18.667 -7.649)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M22.521,16.86H18.963a.3.3,0,0,1-.3-.3v-.449h4.149v.45A.3.3,0,0,1,22.521,16.86Zm-3.659-.55v.254a.1.1,0,0,0,.1.1h3.559a.1.1,0,0,0,.1-.1h0V16.31Z",
    transform: "translate(-18.667 -16.115)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(2.165 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M23.054,14.611l-.176-.083.088.042-.088-.042c.028-.058.645-1.44-1.124-2.558-.033-.02-.335-.209-.335-.455s.3-.435.337-.455c1.767-1.117,1.149-2.5,1.122-2.557l.176-.083c.008.016.723,1.593-1.2,2.806-.064.039-.244.175-.244.289s.179.25.242.288C23.779,13.017,23.064,14.6,23.054,14.611Z",
    transform: "translate(-21.419 -8.42)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0.211 0.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M22.5,14.653H19.1l-.026-.056c-.008-.016-.723-1.594,1.2-2.806.065-.039.244-.175.244-.289s-.162-.241-.242-.289c-1.921-1.214-1.206-2.791-1.2-2.807l.026-.054h3.4l.027.056c.007.016.722,1.593-1.2,2.806-.064.039-.244.175-.244.289s.18.25.242.288c1.921,1.214,1.206,2.791,1.2,2.807Zm-3.274-.2h3.148a2.054,2.054,0,0,0-1.148-2.5c-.032-.02-.335-.209-.335-.455s.3-.435.337-.455a2.054,2.054,0,0,0,1.146-2.5H19.226a2.054,2.054,0,0,0,1.148,2.5c.032.02.335.209.335.455s-.3.434-.337.455a2.051,2.051,0,0,0-1.147,2.5Z",
    transform: "translate(-18.935 -8.351)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0.647 5.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M19.527,15.6H22.31A1.517,1.517,0,0,0,22.33,15a6.248,6.248,0,0,0-2.819,0,1.547,1.547,0,0,0,.016.592",
    transform: "translate(-19.49 -14.843)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0.685 1.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M20.63,11.1a1.184,1.184,0,0,1,.3.26,1.2,1.2,0,0,1,.3-.26,2.216,2.216,0,0,0,1.092-1.369,6.23,6.23,0,0,0-2.779,0A2.218,2.218,0,0,0,20.63,11.1",
    transform: "translate(-19.538 -9.572)",
    fill: "#6c5b7b"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPurple);
export default __webpack_public_path__ + "static/media/history-purple.87b9f32261034de4cf482e3566cc08cb.svg";
export { ForwardRef as ReactComponent };